import React from 'react';
import QTitle from '@/components/QTitle';

import './index.less';

// 单行开放题
export default function Explain({ info }) {
  return (
    <div className='explain'>
      <QTitle code={info.code} description={info.description} />
    </div>
  );
}
